<button *ngIf="!hideEditButton || !hideRemoveButton" mat-button vueTableMenuOpen vueOverlayOpen
  class="menu-trigger" [matMenuTriggerFor]="outageMenu" (click)="validateDisable()">
  <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu #outageMenu="matMenu" class="all-pools-menu">
  <button *ngIf="!compareDate(outage?.enddate) && !hideEditButton" mat-menu-item (click)="editOutage()"> {{ "button.editOutage" | translate | async }}</button>
  <button *ngIf="!compareDate(outage?.startdate) && !hideRemoveButton" mat-menu-item (click)="openRemoveConfirmDialog()">
    {{ "button.removeOutage" | translate | async }}
  </button>
</mat-menu>